export const getImgixAbsoluteURL = (image: string): string => {
  return image
    ? image
        .replace("https://cdn.newonce.me/", "https://newonce.imgix.net/")
        .replace(
          "https://black-steel.app.elpassion.com/",
          "https://newonce.imgix.net/"
        )
    : "";
};
